import { Injectable } from "@angular/core";
import { ContatoriVO } from "@app/shared/vo/contatoriVO";
import { BehaviorSubject, Observable } from "rxjs";
import { distinctUntilChanged } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class ContatoriStore {
  private contatori: BehaviorSubject<ContatoriVO> = new BehaviorSubject<
    ContatoriVO
  >(null);

  constructor() {}

  public setContatori(contatori: ContatoriVO) {
    console.log("[ContatoriStore][setContatori]", contatori);
    this.contatori.next(contatori);
  }

  public getContatori(): Observable<ContatoriVO> {
    console.log("[ContatoriStore][getContatori]", this.contatori);
    return this.contatori.asObservable().pipe(distinctUntilChanged());
  }

  public resetContatori() {
    console.log("[ContatoriStore][resetContatori]");
    this.contatori.next(null);
  }
}
